<!-- <div class="container-fluid">
    <div class="row mt-3 mb-3">
        <div class="col-md-6">
            <h2>Detail Diagnostics <span class="Appkit4-icon icon-star-outline"></span></h2>
        </div>
        <div class="col-md-4">
            <ap-search
                [searchType]="'secondary'"
                [placeholder]="'Search'"
                [(ngModel)]="baseValue"
                (onKeydown)="filterBase($event)">
            </ap-search>
        </div>
        <div class="col-md-2">
            <div class="row">
                <div class="col-md-3">
                    <div class="iconContainer">
                        <span class="Appkit4-icon icon-filter-outline icon"></span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="iconContainer">
                        <span class="Appkit4-icon icon-comment-outline icon"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-2">
                    <label>Views</label>
                </div>
                <div class="col-md-4">
                    <ap-dropdown [list]="viewList" [selectType]="'single'" [title]="'View'" [inputAriaLabel]="'View'" (onSelect)="setView($event);">
                        <ap-dropdown-list-item *ngFor="let item of viewList" [item]="item"></ap-dropdown-list-item>
                    </ap-dropdown>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <ap-dropdown [list]="actionsList" [selectType]="'single'" [title]="'Action'" [inputAriaLabel]="'Action'" (onSelect)="selectedAction($event);">
                                <ap-dropdown-list-item *ngFor="let item of actionsList" [item]="item"></ap-dropdown-list-item>
                            </ap-dropdown>
                        </div>
                        <div class="col-md-6">
                            <ap-button [label]="'Manage View'" class="ap-mr-spacing-3" [btnType]="'secondary'" (onClick)="btnClick()">
                            </ap-button>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="iconContainer">
                                <span class="Appkit4-icon icon-comment-outline icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    <!-- <div class="row">
        <div class="col-md-12">
            <table>
                <tr>
                  <th *ngFor="let header of tableData.headers; let i = index">{{header.lable}}</th>
                </tr>
                <tr *ngFor="let row of tableData.Data; let j = index">
                  <td *ngFor="let col of row">{{col.value}}</td>
                </tr>
              </table>
        </div>
    </div> -->

   <!--<div class="row">
        <div class="col-md-12">
         <gtw-detail-diagnostic-data-table style="width:100%;margin-top:15px" [table-sheet]=this.detail_summary_data_sheets[0]></gtw-detail-diagnostic-data-table> 
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <table>
                <thead>
                    <tr>
                        <th><ap-checkbox> </ap-checkbox></th>
                        <th>LEID</th>
                        <th>ME Code</th>
                        <th>TB Loaded <span class="Appkit4-icon icon-wifi-fill wifiIcon"></span><span class="Appkit4-icon icon-information-outline"></span></th>
                        <th>TB Net To Zero</th>
                        <th>PY TB Loaded</th>
                        <th>Adjust PY Net Zero</th>
                        <th>Entity Begin</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of tableData.Data">
                        <td><ap-checkbox> </ap-checkbox></td>
                        <td>{{row.LEID}}</td>
                        <td>{{row.ME_Code}}</td>
                        <td><span *ngIf="row.TB_Loaded=='Y'" class="Appkit4-icon icon-link-outline"></span><span *ngIf="row.TB_Loaded=='Y'" class="error">Error</span> <span *ngIf="row.TB_Loaded=='N'" class="noError">No Error</span></td>
                        <td><span *ngIf="row.TB_Net_To_Zero=='Y'" class="Appkit4-icon icon-link-outline"></span><span *ngIf="row.TB_Net_To_Zero=='Y'" class="error">Error</span> <span *ngIf="row.TB_Net_To_Zero=='N'" class="noError">No Error</span></td>
                        <td><span *ngIf="row.PY_TB_Loaded=='Y'" class="Appkit4-icon icon-link-outline"></span><span *ngIf="row.PY_TB_Loaded=='Y'" class="error">Error</span> <span *ngIf="row.PY_TB_Loaded=='N'" class="noError">No Error</span></td>
                        <td><span *ngIf="row.Adjust_PY_Net_Zero=='Y'" class="Appkit4-icon icon-link-outline"></span><span *ngIf="row.Adjust_PY_Net_Zero=='Y'" class="error">Error</span> <span *ngIf="row.Adjust_PY_Net_Zero=='N'" class="noError">No Error</span></td>
                        <td>{{row.Entity_Begin}}</td>
                    </tr>
                </tbody>
              </table>
        </div>
    </div>
</div> -->
<div class="container-fluid">
    <div class="row mt-3 mb-3">
        <div class="col-md-11 screen-label">
            <span>Detail Diagnostics <span class="icon fa fa-star-o" style="vertical-align: middle; font-size: 20px;"></span></span>
        </div>
        <div class="col-md-1">
            <div class="row">
                <div class="col-md-12">
                    <div class="iconContainer">
                        <span class="Appkit4-icon icon-filter-outline customList" (click)="showFilter()">
                            @if (selectedParams!=undefined) {
<i class="fa fa-circle" 
                            style="font-size: 8px;color: #D04A02;padding-left: 2px;
                            padding-bottom: 6px"></i>
}

                        </span>
                    </div>
                        <div [hidden]="isShow">
                        <!-- <div *ngIf="isShow"> -->
                            <gtw-dashboard-filter
                                (close-dashboard-filter)="closeFilterPanel($event)"
                                (filterSelectedEmitter)="loadDetailGrid($event)"
                               ></gtw-dashboard-filter>
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>